export const statusOptions = [
    {
        label: "远程指导",
        value: "远程指导"
    },
    {
        label: '现场维修',
        value: '现场维修',
    },
    {
        label: '设备返厂',
        value: '设备返厂',
    },
    {
        label: '问题分析',
        value: '问题分析',
    },
    // {
    //     label: "无法处理",
    //     value: "无法处理"
    // },
    {
        label: '已完成',
        value: '已完成',
    },
];

export const afterSaleOptions = [
    {
        label: "现场维修",
        value: "现场维修"
    },
    {
        label: "设备返厂",
        value: "设备返厂"
    },
    {
        label: "远程指导",
        value: "远程指导"
    }
];

export const questionTypeOptions = [
    {
        label: "物料导致",
        value: "物料导致"
    },
    {
        label: "结构导致",
        value: "结构导致"
    },
    {
        label: "电子导致",
        value: "电子导致"
    },
    {
        label: "光学导致",
        value: "光学导致"
    },
    {
        label: "软件导致",
        value: "软件导致"
    },
    {
        label: "装配导致",
        value: "装配导致"
    },
    {
        label: "工艺导致",
        value: "工艺导致"
    },
    {
        label: "其他问题",
        value: "其他问题"
    }
];
